(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("range", [], factory);
	else if(typeof exports === 'object')
		exports["range"] = factory();
	else
		root["range"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 